
import { performRequest } from "api/performRequest"

export const loginApi = (params) => {
    return performRequest("post", `api/token/`,params)
}


export const currentUserApi = (params) => {
    return performRequest("get", `api/ess/whoami/`,params)
}


export const forgotPasswordApi = (params) => {
    return performRequest("post", `api/forget-password/`,params, false)
}

export const resetPasswordApi = (params) => {
    return performRequest("post", `api/reset-password/`,params, false)
}


export const invitationApi = (params) => {
    return performRequest("post", `api/ess/invite-accept/`,params, false)
}


export const updatePasswordApi = (params) => {
    return performRequest("put", `api/update-password/`,params,)
}


